

































import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IFilter, ISorter } from "@/models/tables";

@Component({
  components: {
    "order-templates-provider": () =>
      import(
        "@/components/app/admin/settings/orderTemplates/orderTemplatesProvider.vue"
      ),
    "order-templates-table": () =>
      import(
        "@/components/app/admin/settings/orderTemplates/orderTemplatesTable.vue"
      )
  }
})
export default class OrderTemplatesView extends Vue {
  @Prop({ default: () => () => [] })
  public availableFilters!: () => IFilter[];

  @Prop({ default: () => () => [] })
  public availableSorters!: () => ISorter[];
}
